import React, { useState, useEffect } from "react";
import * as Icon from "react-feather";
import { Modal } from "@material-ui/core";
//@MUI
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Select,
  TextField,
  MenuItem,
  CircularProgress,
  Box,
  Typography,
} from "@material-ui/core";
import { Asterisk } from "phosphor-react";
//Validators
import { useFormik } from "formik";
import * as yup from "yup";
//
import useStyles from "./AssetsPageEditAssetModal.styles";
import { fdelete, fget, fpatch, uploadFile } from "./../../../API/callsAPI";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useHistory } from "react-router-dom";
import UploadFile from "../../Utilities/UploadFile/UploadFile";
import ModalTitleAndButtons from "../../Utilities/ModalTitleAndButtons/ModalTitleAndButtons.component";
import ConfirmDeleteFile from "../../Utilities/ConfirmDeleteFile/ConfirmDeleteFile.component";
import HelperText from "../../Utilities/HelperText/HelperText";
import CustomInputFieldWithFormik from "../../Utilities/CustomInputFields/CustomInputFieldWithFormik";
import commonStyles from "../../../Utils/commonStyles";

export default function AssetsPageEditAssetModal({
  setSnackValue,
  parentAsset,
  assetType,
  statusList,
  projectId,
  handleDeleteAssetModalState,
  handleEditAssetModal,
  updateRefreshCounter,
  dragScreen,
  assetID,
  handleDragScreen,
  setDragFileEnterModal,
  data,
  customFields,
}) {
  const classes = useStyles();
  const commonClasses = commonStyles();
  const history = useHistory();
  const [departments, setDepartments] = useState([]); //For rendering departments list
  const [thumbnail, uploadThumbnailSet] = useState();
  const [defaultDept, setDefaultDept] = useState();
  const [department, setDepartment] = useState([]); //selected department from dropdown
  const [loading, setLoading] = useState(false);
  const [preLoadedFile, setPreLoadedFile] = useState(false);
  const [deleteFileModal, setDeleteFileModal] = useState(false);
  const [dataEntryFieldType, setDataEntryFieldType] = useState("default");

  useEffect(() => {
    if (parentAsset?.file) {
      const fileNameArray = parentAsset.file.split("/");
      uploadThumbnailSet(fileNameArray[fileNameArray.length - 1]);
      setPreLoadedFile(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentAsset]);

  useEffect(() => {
    fetchDepartments();
    defaultDepartments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleThumbnailUpload = (event) => {
    let file = event.target.files[0];
    event.target.value = null;
    uploadThumbnailSet(file);
    setPreLoadedFile(false);
  };

  const handleClearUpload = (event) => {
    event?.stopPropagation();
    uploadThumbnailSet(null);
  };

  const defaultDepartments = () => {
    let departmentsAlready = [];
    //Fix this warning
    parentAsset &&
      parentAsset?.allowed_dept.map((el) => {
        let temp = {
          title: el.name,
          id: el.id,
        };
        departmentsAlready.push(temp);
        return null;
      });

    setDefaultDept(departmentsAlready);
    setDepartment(departmentsAlready);
  };

  const handleDeptChange = (data) => {
    setDepartment(data);
  };

  // To fetch departments from bff at initial mount
  const fetchDepartments = async () => {
    try {
      const departmentRes = await fget({
        url: `department/?project=${projectId}`,
      });
      setDepartments(
        departmentRes.data.results?.map((el) => {
          const data = {
            title: el.name,
            id: el.id,
          };
          return data;
        })
      );
    } catch (error) {
      console.log(error);
    }
  };

  //Validators
  const EditAssetValidationScheme = yup.object({
    assetName: yup
      .string("String required")
      .label("assetName")
      .min(1, "Too Short!")
      .max(50, "Maximum Character Limit: 50")
      .required(),
    type: yup.string().required("This is a required field"),
  });
  const getInitialValues = () => {
    return customFields?.reduce((acc, field) => {
      acc[field.name] = parentAsset[field.name] || field.default_value || "";
      return acc;
    }, {});
  };

  const formik = useFormik({
    //add initail values for editing a version
    initialValues: {
      assetName: parentAsset ? parentAsset.name : "",
      status: parentAsset && parentAsset.status ? parentAsset.status.id : "",
      type: parentAsset && parentAsset.type ? parentAsset.type : "",
      department: [], //add Default array of departments with id's
      description: parentAsset ? parentAsset?.description : "",
      ...getInitialValues(),
    },
    validationSchema: EditAssetValidationScheme,
    onSubmit: async (values) => {
      let formData = new FormData();
      setLoading(true);
      Object.keys(values).forEach((key) => {
        if (values[key] !== undefined && values[key] !== null) {
          formData.append(key, values[key]);
        }
      });
      formData.append("name", values.assetName);
      formData.append("description", values.description);
      formData.append("project", projectId);
      formData.append("status", values.status);
      formData.append("type", values.type);
      if (department) {
        for (var i = 0; i < department.length; i++) {
          formData.append(`allowed_dept`, department[i].id);
        }
      }
      if (!preLoadedFile && thumbnail) {
        formData.append("file_name", thumbnail.name);
      }

      let updatedAsset = {
        url: `/trackables/asset/v2/${assetID}/`,
        data: formData,
      };

      try {
        const updateAssetRes = await fpatch(updatedAsset);
        if (updateAssetRes.status === 200 || 201) {
          if (thumbnail && !preLoadedFile) {
            getSignedUrl(updateAssetRes.data.id);
          } else {
            setLoading(false);
            setSnackValue({
              isOpen: true,
              message: `SuccessFully Edited ${updateAssetRes.data.name}`,
              isError: false,
            });
            updateRefreshCounter();
            handleEditAssetModal();
          }
        }
      } catch (error) {
        setLoading(false);
        setSnackValue({
          isOpen: true,
          message: `${error}`,
          isError: true,
        });
      }
    },
  });

  const getThumbnail = async (newId) => {
    try {
      const res = fget({
        url: `trackables/asset/${newId}/thumbnail`,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getSignedUrl = async (newId) => {
    try {
      const uploadUrl = await fget({
        url: `trackables/asset/${newId}/upload`,
      });
      if (uploadUrl.status === 200) {
        uploadFile({ url: uploadUrl.data?.signed_url, data: thumbnail })
          .then(() => {
            getThumbnail(newId);
            setSnackValue({
              isOpen: true,
              message: `SuccessFully Edited ${data?.name}`,
              isError: false,
            });
          })
          .finally(() => {
            setLoading(false);
            updateRefreshCounter();
            handleEditAssetModal();
          });
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  const handleDragFile = (e) => {
    if (e.type === "dragenter") {
      //when  file enter- display dragscreen
      handleDragScreen(true);
      setDragFileEnterModal(true);
    }
    //catching the dragged file for uploading
    if (e.type === "drop") {
      handleDragScreen(false);
      uploadThumbnailSet(e.dataTransfer.files[0]);
      setPreLoadedFile(false);
    }
    e.preventDefault();
    e.stopPropagation();
  };

  //function to remove preloaded or selected file
  const handleDeleteFile = async (e) => {
    if (preLoadedFile) {
      try {
        await fdelete({
          url: `trackables/asset/${assetID}/file`,
        });
        updateRefreshCounter();
        setDeleteFileModal(false);
        setSnackValue({
          isOpen: true,
          message: `file deleted successfully`,
          isError: false,
        });
        handleClearUpload(e);
      } catch (error) {
        setSnackValue({
          isOpen: true,
          message: `Something went wrong in file delete`,
          isError: true,
        });
      }
    } else {
      setDeleteFileModal(false);
      setPreLoadedFile(false);
      handleClearUpload(e);
    }
  };

  return (
    <div className={classes.root}>
      <Card
        className={classes.card}
        onDragEnter={(e) => handleDragFile(e)}
        onDrop={(e) => handleDragFile(e)}
        onDragLeave={(e) => handleDragFile(e)}
        onDragOver={(e) => handleDragFile(e)}
      >
        <CardContent className={classes.cardContent}>
          {dragScreen ? (
            <div className={classes.dragScreen}>Drop Here</div>
          ) : (
            ""
          )}
          <form enctype="multipart/form-data" onSubmit={formik.handleSubmit}>
            <ModalTitleAndButtons
              name="Asset"
              type="Edit"
              closeModal={(e) => handleEditAssetModal(e)}
              openDeleteModal={(e) =>
                handleDeleteAssetModalState(e, parentAsset)
              }
            />
            <div
              style={{
                marginTop: "8px",
                display: "flex",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <Button
                onClick={() => setDataEntryFieldType("default")}
                className={
                  dataEntryFieldType === "default"
                    ? classes.selectedButton
                    : classes.defaultButton
                }
              >
                Default fields(5)
              </Button>
              <Button
                onClick={() => setDataEntryFieldType("custom")}
                className={
                  dataEntryFieldType === "custom"
                    ? classes.selectedButton
                    : classes.defaultButton
                }
              >
                Custom fields({customFields?.length})
              </Button>
            </div>
            {dataEntryFieldType === "default" && (
              <>
                <div className={classes.cardContentDiv1}>
                  <div style={{ marginTop: "25px" }}>
                    <div>
                      <span>Asset Name</span>
                      <Asterisk size={12} color="#FF0000" weight="fill" />
                      <div
                        className={classes.cardContentDiv3}
                        style={{ marginTop: "4px" }}
                      >
                        <TextField
                          type="text"
                          id="assetName"
                          className={classes.cardContentInput1}
                          InputProps={{ disableUnderline: true }}
                          name="assetName"
                          value={formik.values.assetName}
                          onChange={formik.handleChange}
                          error={Boolean(formik.errors.assetName)}
                        />
                      </div>
                      {formik.errors.assetName && formik.touched.assetName ? (
                        <HelperText text={formik.errors.assetName} />
                      ) : null}
                    </div>

                    <div style={{ marginTop: "4px" }}>
                      <span>Description</span>
                      <div
                        className={classes.cardContentDiv3}
                        style={{ marginTop: "5px" }}
                      >
                        <TextField
                          type="text"
                          id="desc"
                          placeholder="Enter a project description"
                          className={classes.cardContentInput2}
                          style={{ height: "70px", overflow: "auto" }}
                          InputProps={{
                            disableUnderline: true,
                            style: {
                              fontFamily: "Poppins",
                            },
                          }}
                          name="description"
                          onChange={formik.handleChange}
                          value={formik.values.description}
                          multiline
                        />
                      </div>
                    </div>

                    <div style={{ marginTop: "25px" }}>
                      <div className={classes.displayFlex}>
                        <div>
                          <span>Status</span>
                          <div
                            className={classes.cardContentDiv3}
                            style={{ marginTop: "5px", width: "150px" }}
                          >
                            <Select
                              style={{ width: "100%" }}
                              labelId="demo-simple-select-outlined-label"
                              id="selectStatusA"
                              disableUnderline={true}
                              value={formik.values.status}
                              onChange={formik.handleChange}
                              className={classes.cardContentInput1}
                              name="status"
                              label="Select Status"
                            >
                              <MenuItem
                                value=""
                                className={classes.addNewStatusButton}
                                onClick={() => {
                                  history.push(`/${projectId}/settings/status`);
                                }}
                              >
                                <Icon.Plus />
                                Add new Status
                              </MenuItem>
                              <MenuItem value="" disabled>
                                Select Status
                              </MenuItem>
                              {statusList &&
                                statusList?.map((eachStatus) => (
                                  <MenuItem value={eachStatus.id}>
                                    <span
                                      style={{
                                        height: "15px",
                                        width: "15px",
                                        backgroundColor: `rgb(${eachStatus?.color})`,
                                        borderRadius: "50%",
                                        display: "inline-block",
                                        margin: "0px 5px",
                                      }}
                                    ></span>
                                    {eachStatus.name} - {eachStatus.code}
                                  </MenuItem>
                                ))}
                            </Select>
                          </div>
                        </div>
                        <div style={{ maxWidth: "50%" }}>
                          <span>Status Code</span>
                          <div
                            style={{ marginTop: "5px", cursor: "not-allowed" }}
                            className={classes.cardContentDiv3}
                          >
                            <TextField
                              className={classes.cardContentInput1}
                              InputProps={{
                                disableUnderline: true,
                                style: { opacity: "0.4" },
                              }}
                              disabled
                              fullWidth
                              value={
                                statusList?.find(
                                  (eachStatus) =>
                                    eachStatus.id === formik.values.status
                                )?.code
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ marginTop: "25px" }}>
                      <span>Type</span>
                      <Asterisk size={12} color="#FF0000" weight="fill" />
                      <div
                        className={classes.cardContentDiv3}
                        style={{ marginTop: "4px" }}
                      >
                        <Select
                          style={{
                            width: "100%",
                            height: "25px",
                          }}
                          labelId="demo-simple-select-outlined-label"
                          id="selectType"
                          disableUnderline
                          className={classes.cardContentInput1}
                          value={formik.values.type}
                          onChange={formik.handleChange}
                          name="type"
                          label="Select Type"
                        >
                          <MenuItem value="" disabled>
                            Select Type
                          </MenuItem>
                          {assetType &&
                            assetType.map((eachType) => (
                              <MenuItem value={eachType}>{eachType}</MenuItem>
                            ))}
                        </Select>
                      </div>
                      {formik.errors.type && formik.touched.type ? (
                        <HelperText text={formik.errors.type} />
                      ) : null}
                    </div>
                    {defaultDept ? (
                      <div style={{ marginTop: "25px" }}>
                        <label style={{ marginBottom: "4px" }}>
                          Departments
                        </label>
                        <Autocomplete
                          multiple
                          id="selectDept"
                          defaultValue={defaultDept}
                          options={departments}
                          getOptionLabel={(option) =>
                            option.title ? option.title : "No Option"
                          }
                          className={classes.autoComplete}
                          renderInput={(params) => <TextField {...params} />}
                          onChange={(e, v) => handleDeptChange(v)}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <br />
                <div>
                  <span>Attachment</span>
                  <UploadFile
                    thumbnail={thumbnail}
                    preLoadedFile={preLoadedFile}
                    handleClearUpload={handleClearUpload}
                    handleThumbnailUpload={handleThumbnailUpload}
                    setDeleteFileModal={setDeleteFileModal}
                  />
                </div>
                <br />
              </>
            )}
            {dataEntryFieldType === "custom" && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  marginTop: "8px",
                  minHeight: "200px",
                }}
              >
                {customFields?.length &&
                  customFields.map((sin) =>
                    sin.type === "media" ? (
                      ""
                    ) : sin.type === "dropdown" ? (
                      <Box key={sin.name}>
                        <Typography>{sin?.name}</Typography>
                        <div className={commonClasses.dropdownContainer}>
                          <Select
                            style={{ width: "100%" }}
                            disableUnderline
                            className={commonClasses.select}
                            value={formik.values[sin?.name]}
                            onChange={(e) =>
                              formik.setFieldValue(sin?.name, e.target.value)
                            }
                          >
                            {sin?.options?.length &&
                              sin?.options?.map((option) => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                          </Select>
                        </div>
                        {formik.touched[sin.name] &&
                          formik.errors[sin.name] && (
                            <Typography color="error">
                              {formik.errors[sin.id]}
                            </Typography>
                          )}
                      </Box>
                    ) : (
                      <CustomInputFieldWithFormik
                        key={sin.name}
                        name={sin.name}
                        formik={formik}
                        isRequired={false}
                        label={sin.name}
                        isDisabled={false}
                      />
                    )
                  )}
              </Box>
            )}
            <CardActions className={classes.cardAction}>
              <Button
                fullWidth
                className={classes.done}
                type="submit"
                value="Submit"
                size="small"
                disableElevation
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress style={{ width: "25px", height: "25px" }} />
                ) : (
                  <b>Save</b>
                )}
              </Button>
            </CardActions>
          </form>
        </CardContent>
      </Card>
      <div>
        <Modal
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          open={deleteFileModal}
          onClose={() => setDeleteFileModal(false)}
        >
          <ConfirmDeleteFile
            name={typeof thumbnail === "object" ? thumbnail?.name : thumbnail}
            closeModal={() => {
              setDeleteFileModal(false);
            }}
            deleteFile={() => {
              handleDeleteFile();
            }}
          />
        </Modal>
      </div>
    </div>
  );
}
